import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-night" data-id="element-83" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-page px-3 py-8 sm:px-6 sm:py-10" data-id="element-84" data-mp="9ttj2hqfwb1t">
        <Reveal className="mx-auto flex max-w-2xl flex-col items-center gap-2 rounded-2xl border-2 border-volt bg-carbon p-4 text-center sm:p-6" data-id="element-85" data-mp="9wpe9yawklmk">
          <p className="text-[0.7rem] font-extrabold uppercase tracking-[0.22em] text-steel sm:text-xs" data-id="element-86" data-mp="jrhhpir622p9">
            Tu inversión está protegida
          </p>
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-volt" data-id="element-87" data-mp="skue4uofvmg3">
            <ShieldCheckIcon size={26} className="text-carbon" data-id="element-88" data-mp="xjxlwmvt06rr" />
          </span>
          <h2 id="garantia" className="font-display text-lg uppercase leading-tight text-volt sm:text-2xl" data-id="element-89" data-mp="xm1movyeopnt">
            🛡️ Garantía total de 7 días
          </h2>
          <p className="text-[0.82rem] leading-snug text-steel sm:text-sm" data-id="element-90" data-mp="17g0otuyhc9fr">
            Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si
            consideras que el sistema no es adecuado para ti, puedes solicitar
            un reembolso dentro del período establecido según los términos de
            devolución.
          </p>
        </Reveal>
      </div>
    </section>;
}